import { CircularProgress } from "@mui/material";
import { FC } from "react";
import { useRecoilValue } from "recoil";

import {
  CardNameToFieldInAPI,
  CardNameToOptionsMap,
  CardNameToTypeMap,
  DashboardAuthStatusEnum,
  DashboardCardNameEnum,
  dashboardDtoAtom,
} from "@ryde/shared";

import { DashboardCardContent } from "../../dashboard.card.content";

interface IDashboardLegacyCardBodyProps {
  cardName: DashboardCardNameEnum;
  cardId: string;
}

/**
 * Renders one of the REAL existing dashboard cards (numeric / pie / bar
 * templates) with its live data from `dashboardDtoAtom`, exactly as the current
 * dashboard does (`dashboard.card.tsx`). Used for the default cards so the
 * dynamic dashboard's default layout matches today's dashboard 1:1. The data is
 * fetched once by the page (see `dynamic-dashboard.page.content`).
 */
export const DashboardLegacyCardBody: FC<IDashboardLegacyCardBodyProps> = ({
  cardName,
  cardId,
}) => {
  const dashboardData = useRecoilValue(dashboardDtoAtom);
  const cardType = CardNameToTypeMap[cardName];
  const settings = CardNameToOptionsMap[cardName];
  const byId = dashboardData?.dashboardCardDataById;
  const raw = byId
    ? byId[cardId]
    : dashboardData?.dashboardCardData?.[CardNameToFieldInAPI[cardName]];

  if (!dashboardData) {
    return (
      <div className="dashboard-card-empty">
        <CircularProgress size={22} />
      </div>
    );
  }

  return (
    <DashboardCardContent
      isAuthorized={raw?.status === DashboardAuthStatusEnum.ACCEPTED}
      cardName={cardName}
      cardType={cardType}
      content={
        raw?.data ? settings.mainCardSettings.dataHook(raw.data) : undefined
      }
      settings={settings.mainCardSettings}
    />
  );
};
